import { BASE_URL } from './Config.js';

export class FournisseurService {
  createFournisseur = async (data) => {
    const token = localStorage.getItem('accessToken');
    const res = await fetch(`${BASE_URL}/fournisseur/create`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error('Erreur création');
    return res.json();
  };

  getAllFournisseurs = async () => {
    const token = localStorage.getItem('accessToken');
    const res = await fetch(`${BASE_URL}/fournisseur/all`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
    });
    if (!res.ok) throw new Error('Erreur chargement');
    return res.json();
  };

  getFournisseurById = async (id) => {
    const token = localStorage.getItem('accessToken');
    const res = await fetch(`${BASE_URL}/fournisseur/${id}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
    });
    if (!res.ok) throw new Error('Erreur chargement détail');
    return res.json();
  };

  updateFournisseur = async (id, data) => {
    const token = localStorage.getItem('accessToken');
    const res = await fetch(`${BASE_URL}/fournisseur/update/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error('Erreur mise à jour');
    return res.json();
  };

  deleteFournisseur = async (id) => {
    const token = localStorage.getItem('accessToken');
    const res = await fetch(`${BASE_URL}/fournisseur/delete/${id}`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
    });
    if (!res.ok) throw new Error('Erreur suppression');
    return true;
  };

    searchFournisseurs = async (query) => {
    const token = localStorage.getItem('accessToken');
    if (!token) throw new Error("Aucun token d'accès trouvé.");

    const response = await fetch(`${BASE_URL}/fournisseur/search?query=${encodeURIComponent(query)}`, {
      method: 'GET',
      headers: { 
        'Content-Type': 'application/json', 
        'Authorization': `Bearer ${token}` 
      }
    });

    if (!response.ok) {
      throw new Error('Erreur lors de la recherche des fournisseurs');
    }
    return await response.json();
  };
}